// token.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
    const cookieService = inject(CookieService);

    // Parse the target URL to check the hostname
    let targetHost = '';
    try {
        const url = new URL(req.url);
        targetHost = url.origin; // e.g., "https://queue-relay-testing02.input4you.be"
    } catch {
        // If it's a relative URL, just skip modifying it
        return next(req);
    }

    // Only attach token if the request is to the specific hostname
    if (targetHost === environment.queueRelay) {
        const token = cookieService.get('token');

        if (token) {
            const authReq = req.clone({
                setHeaders: { Authorization: token }
            });
            return next(authReq);
        }
    }

    // Otherwise, pass the request through unchanged
    return next(req);
};
